export const CLASS_TODO_LIST = 'slate-todo-list';
export const CLASS_TODO_LIST_CHECKED = 'slate-todo-list-checked';
